import { ReactElement, useCallback } from 'react';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../components/info/DisplayError';
import Loading from '../../../../components/info/Loading';
import {
  IdentificationTypesAsOptions,
  IdentificationTypesResponse,
} from '../types';
import { getIdentificationTypes } from '../api';

export interface IdentificationTypesOptionsProps<T> {
  children: (props: { data: T }) => ReactElement;
}

const { FetchProvider, FetchConsumer } = createFetchContext<
  {},
  IdentificationTypesResponse
>();

export function IdentificationTypesOptionsLoader({
  children,
}: IdentificationTypesOptionsProps<IdentificationTypesAsOptions>) {
  const request = useCallback(() => {
    return getIdentificationTypes();
  }, []);
  return (
    <FetchProvider request={request} defaultQuery={{}} fetchImmediately>
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return (
              <div className="mx-3">
                <Loading insideCard />
              </div>
            );
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          const identificationTypes = data.identificationTypes.map(
            (identificationType) => {
              return {
                label: identificationType.name,
                value: identificationType.id,
              };
            },
          );

          return children({ data: identificationTypes });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
